import React from 'react';
//import { storeConfig } from '../../config/config';
import { DialogflowQueryType } from '../models/enum';
import './store-selector-detail.scss';
import '../message/message.scss';
import { postMessageToClient } from '../chatservice/communicationService';

type StoreSelectorDetailProps = {
    store: any,
    isHostDevice: boolean,
    setStore: any,
    quickReplyHandler: any,
    setSelectedStoreData: any
}

const StoreSelectorDetail = ({store, isHostDevice, setStore, setSelectedStoreData, quickReplyHandler}: StoreSelectorDetailProps) => {
    const [timeStr1, timeStr2] = store.data.store_trading_hours || ['', ''];

    const onClickHandler = (e: any) => {
        const params:any = {
            selectedStoreId: store.data.storeId,
            selectedStoreName: 'Dan Murphy\'s ' +  store.data.suburb.charAt(0).toUpperCase() + store.data.suburb.slice(1).toLowerCase()
        }
        

        if (!store.isSelected) {
            quickReplyHandler(e, DialogflowQueryType.Event, 'PRODUCT_AVAIL_SET_STORE', false, params);
            store.isSelected = true;
            setStore(parseInt(store.data.storeId));
            setSelectedStoreData(store.data);
        }
    }

    return (
        <div className='store'>
            <div className='store__location'>
                <div className='store__title'>Dan Murphy's <span className='store__suburb'>{store.data.suburb.toLowerCase()}</span></div>
                <div className='store__address'>{store.data.addressLine1}</div>
                <div className='store__address'><span className='store__suburb'>{store.data.suburb.toLowerCase()}</span> {store.data.postcode}</div>
                {store.data.distance && <div className='store__address store__distance'>{store.data.distance}km away</div>}
            </div>
            <div className={'store__hours ' + (isHostDevice && 'store__hours--device')} >
               <div className='store__date'>
                   <span><b>{timeStr1}</b> {timeStr2 && '-'} {timeStr2}</span>
               </div>
            </div>

            <div className="message__text--qr">        
               {!store.isSelected && <span onClick={onClickHandler} className="message__text--click">Select store</span> }
               {store.isSelected && <span className="message__text--selected">Selected</span> }
            </div>
        </div>
    );
}

export {
    StoreSelectorDetail
}